import { createHashHistory } from "history"
import { render } from "htm/preact"
import Router from "preact-router"

import { RoundTables } from "../components/Roundtables"
import { ElfsightPopup } from "../utils/fw"
import { handleNewRoute } from "../utils/routing"
import ReactionWidget from "../components/reactionWidget"

import { CometChat } from "./components/CometChat"
import { Navbar } from "./components/Navbar"
import { Room } from "./components/Room"

import "./styles.css"
import ConnectFour from "src/components/ConnectFour"
import Modal from "src/components/Modal"
import { useRef } from "preact/hooks"
import { Booth } from "src/components/Booth"

const homeButton = {
	width: "2.3%",
	height: "4.3%",
	left: "48.8%",
	top: "94.9%",
	href: "/"
}

const rooms = (entertRef = useRef(null)) => [
	{
		background: "https://static1.tkevents.io/assets/images/61604/Main Lobby.png",
		default: true,
		links: [
			homeButton,
			{
				elfsightPopupID: "c3133e47-04b0-48f9-9507-2211a70b2b9f",
				elfsightPopupTrigger: "",
				height: "23.1%",
				label: "Lobby",
				left: "30%",
				top: "9%",
				width: "35%",
			},
			{
				height: "34.3%",
				href: "/Entertainment-Lounge",
				isExternal: true,
				label: "Entertainment Lounge",
				left: "26.3%",
				top: "33.7%",
				width: "12.2%",
			},
			{
				height: "34.3%",
				href: "/Breakouts",
				isExternal: true,
				label: "Breakouts",
				left: "13.3%",
				top: "33.7%",
				width: "13.2%",
			},
			{
				height: "34.3%",
				href: "/Main-Stage",
				isExternal: true,
				label: "Main Stage",
				left: "38.3%",
				top: "33.7%",
				width: "18.7%",
			},
			{
				height: "34.3%",
				href: "/Expert-Lounge",
				isExternal: true,
				label: "Expert Lounge",
				left: "57.3%",
				top: "33.7%",
				width: "11.3%",
			},
			{
				height: "34.3%",
				href: "/Expo-Hall",
				isExternal: true,
				label: "Expo Hall",
				left: "69.3%",
				top: "33.7%",
				width: "11.3%",
			},
			{
				height: "19.3%",
				href: "/Roundtables",
				isExternal: true,
				label: "Roundtables",
				left: "4.6%",
				top: "79.9%",
				width: "11.3%",
			},
			{
				height: "15.3%",
				href: "#Help-Desk",
				isExternal: true,
				onClick: () => {smartsupp('chat:open')},
				label: "Help Desk",
				left: "67.2%",
				top: "67.3%",
				width: "15.7%",
				radius: "29% 29% 10% 29%"
			},
			{
				height: "15.3%",
				href: "/Workshop",
				isExternal: true,
				label: "Workshop",
				left: "87.1%",
				top: "47.3%",
				width: "11.7%"
			},
		],
		extraInside: true,
		name: "lobby",
	},
	{
		background: "https://static1.tkevents.io/assets/images/61604/Breakout lobby.png",
		name: "Breakouts",
		links: [
			homeButton,
			{
				height: "13.3%",
				href: "/Breakout-One",
				isExternal: true,
				label: "Breakout One",
				left: "32%",
				top: "56.3%",
				width: "6.7%"
			},
			{
				height: "13.3%",
				href: "/Breakout-Two",
				isExternal: true,
				label: "Breakout Two",
				left: "41%",
				top: "56.3%",
				width: "6.7%"
			},
			{
				height: "13.3%",
				href: "/Breakout-Three",
				isExternal: true,
				label: "Breakout Three",
				left: "50.2%",
				top: "56.3%",
				width: "6.7%"
			},
			{
				height: "13.3%",
				href: "/Breakout-Four",
				isExternal: true,
				label: "Breakout Four",
				left: "59.8%",
				top: "56.3%",
				width: "6.7%"
			}
		]
	},
	{
		background: "https://static1.tkevents.io/coffeechat-3/Breakout 1 v3.png",
		name: "Breakout One",
		links: []
	},
	{
		background: "https://static1.tkevents.io/coffeechat-3/Breakout 2 v3.png",
		name: "Breakout Two",
		links: []
	},
	{
		background: "https://static1.tkevents.io/coffeechat-3/Breakout 3 v3.png",
		name: "Breakout Three",
		links: []
	},
	{
		background: "https://static1.tkevents.io/coffeechat-3/Breakout 4 v3.png",
		name: "Breakout Four",
		links: []
	},
	{
		background: "https://static1.tkevents.io/coffeechat-3/Main%20Stage%20v3.png",
		name: "Main Stage",
		extraInside: true,
		extras: (
			<>
				<iframe
					style="height: 65.75%; width: 65.9%; top: 4.4%; left: 17%; position:absolute; cursor:pointer; display:block; z-index:5; overflow:hidden; border: none;"
					className="auditorium-livestream"
					src="https://player.vimeo.com/video/687330885?h=59ef7a327d&/embed?autopause=0&autoplay=1"
					allowfullscreen
				/>
				<ReactionWidget emojis={["💯", "👍", "🥱", "⌛"]} style={{ width: "13.8%", height: "37.3%", left: "84.5%", top: "8.2%" }} />
			</>
		),
		links: [
			homeButton,
			{
				onClick: () => { document.getElementById("questions1").click() },
				height: "14%",
				label: "Q and A",
				left: "1.7%",
				top: "55.1%",
				width: "14%"
			},
		]
	},
	{
		background: "https://static1.tkevents.io/coffeechat-3/ROUNDTABLE.jpg",
		name: "Roundtables",
		extras: <RoundTables />,
		links: [
			homeButton
		]
	},
	{
		background: "https://static1.tkevents.io/assets/images/61604/Coffee Talk.png",
		name: "Expert Lounge",
		links: [
			homeButton
		]
	},
	{
		background: "https://static1.tkevents.io/assets/images/61604/Expo Hall.png",
		name: "Expo Hall",
		links: [
			homeButton,
			{
				height: "29%",
				href: "/Expo-Room-One",
				isExternal: true,
				label: "Expo Room 1",
				left: "16.9%",
				top: "17.1%",
				width: "67%"
			},
			{
				height: "29%",
				href: "/Expo-Room-2",
				isExternal: true,
				label: "Expo Room 2",
				left: "16.9%",
				top: "51.1%",
				width: "67%"
			}
		]
	},
	{
		background: "https://static1.tkevents.io/TK-MAIN-VIEW-mountains.png",
		name: "BYOB",
		links: [
			homeButton,
		],
		extraInside: true,
		extras: <>
			<Booth boothId={"7cec10c6-f377-4c58-9f99-7702f6147c2d"} position={{top: "6%", left: "10%", width: "34%"}}/>
			<Booth boothId={"b53aac89-a1cd-49d3-b2b5-1e909e8b9bdc"} position={{top: "6%", left: "58%", width: "34%"}}/>
			<Booth boothId={"2dcebf6a-5df0-4d7a-8242-7d88b65e0469"} position={{top: "43%", left: "3%", width: "46%"}}/>
			<Booth boothId={"c1464d89-dc12-4e2c-a1c2-5affff42585a"} position={{top: "43%", left: "53%", width: "46%"}}/>
		</>
	},
	{
		background: "https://static1.tkevents.io/TK-MAIN-VIEW-mountains.png",
		name: "Management Booths",
		links: [
			homeButton,
		],
		extraInside: true,
		extras: <>
			<Booth boothId={"0a46f7df-9d02-4e22-9eca-7bd5396c9497"} position={{top: "6%", left: "10%", width: "34%"}}/>
			<Booth boothId={"614d4e9b-3516-41bf-91b1-34bd835bec7f"} position={{top: "6%", left: "58%", width: "34%"}}/>
			<Booth boothId={"a97e16b2-b71b-471d-96fa-cc98125c1cec"} position={{top: "43%", left: "3%", width: "46%"}}/>
			<Booth boothId={"ea9ff46e-bb3e-462d-8088-a7672de19b6c"} position={{top: "43%", left: "53%", width: "46%"}}/>
		</>
	},
	{
		background: "https://static1.tkevents.io/assets/images/61604/Expo Room.png",
		name: "Expo Room One",
		links: [
			homeButton,
			{
				onClick: () => { document.getElementById("CDW-Breakout2-CreatingWorld").click() },
				height: "30%",
				label: "Watch Video",
				left: "8.5%",
				top: "28.1%",
				width: "24.8%"
			},
			{
				onClick: () => { CometChatWidget.chatWithGroup("sponsor1"); CometChatWidget.openOrCloseChat(true) },
				height: "30%",
				href: "#Expo-Room-One",
				isExternal: true,
				label: "Expo Room 2",
				left: "38.5%",
				top: "28.1%",
				width: "24.8%"
			},
			{
				height: "30%",
				href: "#Expo-Room-One",
				isExternal: true,
				label: "Expo Room 2",
				left: "65.5%",
				top: "28.1%",
				width: "24.8%"
			},
			{
				height: "28.8%",
				href: "#Expo-Room-One",
				isExternal: true,
				label: "Expo Room 2",
				left: "3.5%",
				top: "58.1%",
				width: "30.8%"
			},
			{
				height: "28.8%",
				href: "#Expo-Room-One",
				isExternal: true,
				label: "Expo Room 2",
				left: "35.5%",
				top: "58.1%",
				width: "29.8%"
			},
			{
				height: "28.8%",
				href: "#Expo-Room-One",
				isExternal: true,
				label: "Expo Room 2",
				left: "65.5%",
				top: "58.1%",
				width: "26.8%"
			}
		]
	},
	{
		background: "https://static1.tkevents.io/assets/images/61604/Expo Room.png",
		name: "Expo Room 2",
		links: [
			homeButton,
			{
				height: "30%",
				href: "/Expo-Room-2",
				isExternal: true,
				label: "Expo Room 2",
				left: "8.5%",
				top: "28.1%",
				width: "24.8%"
			},
			{
				height: "30%",
				href: "/Expo-Room-2",
				isExternal: true,
				label: "Expo Room 2",
				left: "38.5%",
				top: "28.1%",
				width: "24.8%"
			},
			{
				height: "30%",
				href: "/Expo-Room-2",
				isExternal: true,
				label: "Expo Room 2",
				left: "65.5%",
				top: "28.1%",
				width: "24.8%"
			},
			{
				height: "28.8%",
				href: "/Expo-Room-2",
				isExternal: true,
				label: "Expo Room 2",
				left: "3.5%",
				top: "58.1%",
				width: "30.8%"
			},
			{
				height: "28.8%",
				href: "/Expo-Room-2",
				isExternal: true,
				label: "Expo Room 2",
				left: "35.5%",
				top: "58.1%",
				width: "29.8%"
			},
			{
				height: "28.8%",
				href: "/Expo-Room-2",
				isExternal: true,
				label: "Expo Room 2",
				left: "65.5%",
				top: "58.1%",
				width: "26.8%"
			}
		]
	},
	{
		background: "https://static1.tkevents.io/assets/images/61604/Games Room.png",
		name: "Entertainment Lounge",
		links: [
			homeButton,
			{
				hoverMessage: "Connect4!",
				height: "23.8%",
				href: "#",
				label: "Game",
				left: "28.5%",
				top: "63.1%",
				width: "10.8%",
				onClick: () => {
					if (entertRef.current === null) return;
					entertRef.current.toggle()
				}
			}
		],
		extras: <Modal ref={entertRef}>
			{/* <ConnectFour username={window.dataLayer[0]["Full Name"]} url="gameconn.tkevents.io" /> */}
		</Modal>
		// extras: <div style = "position: absolute; top: 10%; left: 10%; background: white; padding: 10px; border-radius: 7px;">
		// 	<ConnectFour username={window.dataLayer[0]["Full Name"]} url = "gameconn.tkevents.io"/>
		// </div>
	}
]

const popups = [
	{
		ID: "c3133e47-04b0-48f9-9507-2211a70b2b9f",
		trigger: "BT-info-desk-pop-up",
	},
	{
		ID: "35d42c0c-28eb-454d-93de-4a861db209d2",
		trigger: "questions1",
	},
	{
		ID: "7b0a4854-7c87-44bf-972d-7cf00bce1e82",
		trigger: "CDW-Breakout2-CreatingWorld"
	},
]

const Main = () => {
	const hook = useRef(null)
	const r = rooms(hook)
	return <>
		<Navbar />
		<Router
			history={createHashHistory()}
			onChange={handleNewRoute(61604, 1337)}
		>
			{r.map(Room)}
		</Router>
		{popups.map(ElfsightPopup)}
		<script src="https://apps.elfsight.com/p/platform.js" defer />
		<CometChat />
	</>
}

render(<Main />,
	document.getElementById("content"),
)